/* global importName */
const HostRead = () => importName('@/scenes/HostRead/HostRead.vue', 'host-read')

const routes = [
  // /accounts/:accountId/shows/:showId/ad-creative
  {
    path: 'ad-creative',
    name: 'ad-creative',
    component: HostRead,
    props: true,
    meta: {
      breadcrumbs: () => [
        { title: 'Ad Creative' }
      ],
      archive: false
    }
  },
  {
    path: 'ad-creative/:adCreativeId',
    name: 'ad-creative.modal',
    component: HostRead,
    props: true,
    meta: {
      breadcrumbs: () => [
        { title: 'Ad Creative' }
      ],
      archive: false
    }
  },
  {
    path: 'ad-creative/archive',
    name: 'ad-creative-archive',
    component: HostRead,
    props: true,
    meta: {
      breadcrumbs: () => [
        { title: 'Ad Creative' }
      ],
      archive: true
    }
  },
  {
    path: 'ad-creative/archive/:adCreativeId',
    name: 'ad-creative-archive.modal',
    component: HostRead,
    props: true,
    meta: {
      breadcrumbs: () => [
        { title: 'Ad Creative' }
      ],
      archive: true
    }
  }
]

export default routes
